/*
  geolocation.js
    geolocation module

*/
import * as types from '@/store/mutation-types'
import { getGeoLocation, updateGeoLocation } from '@/api'
import { LS_TOKEN_KEY, isNullorUndefined } from '@/common'
import { sLog } from '@/common/simple-logger'

export default {
  state: {
    sGeoLocationList: [],
  },
  getters: {
    geoLocationList: state => state.sGeoLocationList,
  },
  actions: {
    // -------------------------------------------------------------------------
    aGetGeoLocationList: async (context, companyId) => {
      sLog.debug('@action getGeoLocationList : ' + companyId)
      const result = await getGeoLocation(companyId, localStorage.getItem(LS_TOKEN_KEY))

      if (!result.error && !result.body.error) {
        let geolocation_list = []
        let work_glist = result.body.body
        const user_list = context.rootState.sUserList

        // ユーザリストを元に、位置情報一覧データを作成
        for (let i = 0; i < user_list.length; ++i) {
          let user_ginfo = {}
          let f_ginfo = work_glist.find((ginfo) => {
            return (ginfo.staff_id.toString() === user_list[i].staff_id.toString())
          })
          if (isNullorUndefined(f_ginfo)) {
            // 位置情報リストにデータがないユーザは空データ
            user_ginfo = {
              staff_id: user_list[i].staff_id,
              name: user_list[i].name,
              latitude: '',
              longitude: '',
              message: '',
              company_id: user_list[i].company_id,
              send_time: ''
            }
          }
          else {
            user_ginfo = f_ginfo
            user_ginfo.name = user_list[i].name
          }
          geolocation_list.push(user_ginfo)
        }
        context.commit(types.SET_GEOLOCATION_LIST, geolocation_list)
      }

      return result
    },
    // -------------------------------------------------------------------------
    async aUpdateGeoLocation (context, payload) {
      sLog.debug('@action updateGeoLocation ' + JSON.stringify(payload))

      const result = await updateGeoLocation(
        payload.companyId,
        payload.memberId,
        payload.geolocation,
        localStorage.getItem(LS_TOKEN_KEY)
      )

      if (result.error || result.body.error) {
        sLog.warn('failed update geolocation')
      }

      return result
    },
  },
  mutations: {
    // -------------------------------------------------------------------------
    // set geolocation information
    [types.SET_GEOLOCATION_LIST] (state, geoLocationList) {
      //sLog.debug('@store set geolocation list : ' + JSON.stringify(geoLocationList))
      state.sGeoLocationList = geoLocationList
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/geolocation.js